import axios from "axios"
import baseURL from "../config/api";

export const getAdminSettings = async (token: string) => {
    return await getFetch("AdminSettings", token);
}

export const getAdminSetting = async (primaryKey: string, token: string) => {
    return await getFetch(`AdminSettings/${primaryKey}`, token)
}

export const postAdminSetting = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}AdminSettings`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_AdminSetting = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}AdminSettings`,
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_AdminSetting = async (primaryKey: string, token: string) => {
    return await axios({
        url: `${baseURL}AdminSettings`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

const getFetch = async (url: string, token: string, params = {}) => {
    return await axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}
